export type EmployeeTimeEntryType =
  | 'work'
  | 'vacation'
  | 'sickness'
  | 'public_holiday'
  | 'shift_free'
  | 'overtime_comp'
  | 'unpaid_absence'
  | 'special_leave'
  | 'sickness_benefit';

export const ENTRY_TYPE_LABEL: Record<EmployeeTimeEntryType, string> = {
  work: 'Arbeit',
  vacation: 'Urlaub',
  sickness: 'Krank',
  public_holiday: 'Feiertag',
  shift_free: 'Freischicht',
  overtime_comp: 'Freizeitausgleich',
  unpaid_absence: 'Unbezahlte Fehlzeit',
  special_leave: 'Sonderurlaub',
  sickness_benefit: 'Krankengeld',
};

export const ENTRY_TYPE_COLORS: Record<EmployeeTimeEntryType, string> = {
  work: 'bg-blue-100 text-blue-700',
  vacation: 'bg-amber-100 text-amber-800',
  sickness: 'bg-rose-100 text-rose-700',
  public_holiday: 'bg-emerald-100 text-emerald-700',
  shift_free: 'bg-slate-200 text-app-text-muted',
  overtime_comp: 'bg-violet-100 text-violet-700',
  unpaid_absence: 'bg-orange-100 text-orange-800',
  special_leave: 'bg-teal-100 text-teal-800',
  sickness_benefit: 'bg-pink-100 text-pink-800',
};

export const ENTRY_TYPE_ORDER: ReadonlyArray<EmployeeTimeEntryType> = [
  'work',
  'vacation',
  'special_leave',
  'sickness',
  'sickness_benefit',
  'public_holiday',
  'unpaid_absence',
  'shift_free',
  'overtime_comp',
];
